import { render, staticRenderFns } from "./SlsPT_Items.vue?vue&type=template&id=13f82ed2"
import script from "./SlsPT_Items.vue?vue&type=script&lang=js"
export * from "./SlsPT_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports